import type { ReactNode } from 'react';

export const symbol_stockpot: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M210-160q-37.5 0-63.75-26.25T120-250v-378q0-13.17 8.63-22.09Q137.25-659 150-659h659q13.17 0 22.09 8.91Q840-641.17 840-628v378q0 37.5-26.25 63.75T750-160H210Zm-30-439v349q0 12.75 8.63 21.37Q197.25-220 210-220h540q12.75 0 21.38-8.63Q780-237.25 780-250v-349H180Zm190-161v-50q0-12.75 8.63-21.38Q387.25-840 400-840h160q12.75 0 21.38 8.62Q590-822.75 590-810v50h220q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.91 21.82-8.92 9-22.09 9H150q-12.75 0-21.37-8.88-8.63-8.87-8.63-22 0-13.12 8.91-21.62 8.91-8.5 22.09-8.5h219Zm110 350Z"
		/>
	</svg>
);
